import AppTextInput from "@toothfairy/shared-ui/AppTextInput";
import React, { useEffect } from "react";
import { View } from "react-native";
import ToothFairyButton from "../../../../../Components/ToothFairyComponents/ToothFairyButton";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppButtonMenu from "@toothfairy/shared-ui/AppButtonMenu";
import AppTheme from "@toothfairy/shared-ui/AppTheme";

const QaConfigToolbar = ({
  searchBtnLabel = "Search",
  createBtnLabel = "Create",
  searchBtnAccLabel = "searchButton",
  createBtnAccLabel = "createButton",
  options = [],
  handleSearch = () => {},
  handleCreation = () => {},
}) => {
  const [labelText, setLabelText] = React.useState("");
  const [valueText, setValueText] = React.useState("");
  const [modelText, setModelText] = React.useState("");
  const [forceOpening, setForceOpening] = React.useState(false);
  const { currentTheme } = AppTheme?.useTheme();

  // Auto-execute search when name or description changes
  useEffect(() => {
    handleSearch(modelText, labelText, valueText);
  }, [labelText, valueText]);
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        marginTop: -10,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <AppTextInput
          value={labelText}
          onChangeText={setLabelText}
          style={{
            // fontSize: 16,
            marginLeft: 0,
          }}
          placeholder="Name"
        />
      </View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <AppTextInput
          value={valueText}
          onChangeText={setValueText}
          style={{
            // fontSize: 16,
            marginLeft: 0,
          }}
          placeholder="Description"
        />
      </View>

      <ToothFairyButton
        title={"Hire Agent"}
        onPress={() => {
          setForceOpening(Date.now().toString());
          handleCreation();
          // commented as this function gets called only when the user will click create agent from scratch
          // handleCreation(
          //   "Chatbot",
          //   options.find((option) => option?.id === "Chatbot")?.label
          // );
        }}
        wrapperStyle={{ marginTop: 10 }}
      />
    </View>
  );
};

export default QaConfigToolbar;
